module.exports = __webpack_public_path__ + "img/vantagensLandPage.1828b0be.png";